import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetDiscussionsFailed, EGetDiscussionsActionType } from './types';

export const getDiscussionsFailed: () => TGetDiscussionsFailed = actionGenerator<EGetDiscussionsActionType.Failed>(
  EGetDiscussionsActionType.Failed,
);
